import DestinationAccount, { AccountType } from "../class/destinationAccount";
import { AcceptsRothFundsResponse, TransferAccountType, TransferIntentResponse } from "../class/transferIntent";
import { isEmployerSponsored } from "./isEmployerSponsored";

const formatDestinationAccount = (
  intentDetails: TransferIntentResponse["transferAccount"],
  extraAccounts: TransferIntentResponse["accounts"],
): DestinationAccount => {
  const extraIRAAccount = extraAccounts.filter(
    (extraAccount) => extraAccount.accountType === TransferAccountType.IRA,
  )[0];
  const extraRothIRAAccount = extraAccounts.filter(
    (extraAccount) => extraAccount.accountType === TransferAccountType.ROTH_IRA,
  )[0];
  return isEmployerSponsored(intentDetails.accountType)
    ? new DestinationAccount({
        destinationAccountType: AccountType.employerSponsored,
        planSponsor: intentDetails.planSponsor || "INFO PENDING",
        planName: intentDetails.planName || "INFO PENDING",
        planNumber: intentDetails.planNumber || "INFO PENDING",
        planType: intentDetails.acceptsRothFunds === AcceptsRothFundsResponse.YES ? "BOTH" : "TRADITIONAL",
        providerName: intentDetails.providerName,
        statementSkipped: "TRUE",
        traditionalIraAccountNumber: extraIRAAccount?.accountNumber || null,
        rothIraAccountNumber: extraRothIRAAccount?.accountNumber || null,
      })
    : new DestinationAccount({
        destinationAccountType: AccountType.ira,
        traditionalIraAccountNumber: intentDetails.accountNumber,
        providerName: intentDetails.providerName,
        statementSkipped: "TRUE",
        yetToOpen: intentDetails.accountNumber === null ? true : false,
        rothIraAccountNumber: extraRothIRAAccount?.accountNumber || null,
      });
};

export default formatDestinationAccount;
